module.exports = "/static-assets/_next/static/images/img-45c3c2887a-2d514dc7160817c3255e278c8df662db.webp";